import { render, staticRenderFns } from "./giga.vue?vue&type=template&id=0b879c86&scoped=true&"
import script from "./giga.vue?vue&type=script&lang=js&"
export * from "./giga.vue?vue&type=script&lang=js&"
import style0 from "./giga.vue?vue&type=style&index=0&id=0b879c86&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b879c86",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VContainer,VSelect})
